
export const FETCH_DASHBOARD = "FETCH_DASHBOARD";
export const FETCH_DASHBOARD_START = "FETCH_DASHBOARD_START";
export const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
export const FETCH_DASHBOARD_ERROR = "FETCH_DASHBOARD_ERROR";

export const FETCH_DASHBOARD_MODALITY_COUNTS = "FETCH_DASHBOARD_MODALITY_COUNTS";
export const FETCH_DASHBOARD_MODALITY_COUNTS_START = "FETCH_DASHBOARD_MODALITY_COUNTS_START";
export const FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS = "FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS";
export const FETCH_DASHBOARD_MODALITY_COUNTS_ERROR = "FETCH_DASHBOARD_MODALITY_COUNTS_ERROR";

export const fetchDashboard = () => {
    return {
        type: FETCH_DASHBOARD,
    };
};


export const fetchDashboardModalityCounts = (payload) => {
    return {
        type: FETCH_DASHBOARD_MODALITY_COUNTS,
        payload
    };
}